import React, {createContext, useContext, useReducer} from "react";

//Prepara il livello dati (per ricevere i dati) (ciò che li riceve e li contiene) (i nostri dati sono i prodotti)
export const StateContext = createContext();

export const StateProvider = ({reducer, initialState, children}) => (
    <StateContext.Provider value={useReducer(reducer, initialState)}>
        {children}
    </StateContext.Provider>
);

//Estrae i dati dal contenitore di dati
export const useStateValue = () => useContext(StateContext);